<div class="add-container">
    <h1 class="add-title">Adaugă configurare nouă</h1>

    <!-- Selecție grup (modul/locație/serviciu) - Full width cu typeahead -->
    <div class="group-selection-section mb-4">
        <!-- Modul -->
        <div class="row mb-3">
            <div class="col-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Modul</mat-label>
                    <input type="text"
                        matInput
                        [formControl]="modulControl"
                        [matAutocomplete]="autoModul"
                        #modulTrigger="matAutocompleteTrigger"
                        (focus)="onFocusModul(modulTrigger)"
                        placeholder="Căutați sau selectați...">
                    <mat-autocomplete #autoModul="matAutocomplete" [displayWith]="displayModul">
                        <mat-option *ngFor="let modul of filteredModule$ | async" [value]="modul">
                            {{ modul.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-icon matSuffix>arrow_drop_down</mat-icon>
                    <mat-error *ngIf="modulControl.invalid && modulControl.touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <!-- Locație -->
        <div class="row mb-3">
            <div class="col-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Locație</mat-label>
                    <input type="text"
                        matInput
                        [formControl]="locatieControl"
                        [matAutocomplete]="autoLocatie"
                        #locatieTrigger="matAutocompleteTrigger"
                        (focus)="onFocusLocatie(locatieTrigger)"
                        placeholder="Căutați sau selectați...">
                    <mat-autocomplete #autoLocatie="matAutocomplete" [displayWith]="displayLocatie">
                        <mat-option *ngFor="let locatie of filteredLocatii$ | async" [value]="locatie">
                            {{ locatie.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-icon matSuffix>arrow_drop_down</mat-icon>
                    <mat-error *ngIf="locatieControl.invalid && locatieControl.touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <!-- Serviciu -->
        <div class="row">
            <div class="col-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Serviciu</mat-label>
                    <input type="text"
                        matInput
                        [formControl]="serviciuControl"
                        [matAutocomplete]="autoServiciu"
                        #serviciuTrigger="matAutocompleteTrigger"
                        (focus)="onFocusServiciu(serviciuTrigger)"
                        placeholder="Căutați sau selectați...">
                    <mat-autocomplete #autoServiciu="matAutocomplete" [displayWith]="displayServiciu">
                        <mat-option *ngFor="let serviciu of filteredServicii$ | async" [value]="serviciu">
                            {{ serviciu.web_name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-icon matSuffix>arrow_drop_down</mat-icon>
                    <mat-error *ngIf="serviciuControl.invalid && serviciuControl.touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>

    <!-- Zile configurate -->
    <div class="zile-section mb-4">
        <h4 class="section-subtitle">Zile configurate</h4>

        <div class="zile-list" *ngIf="zile.length > 0">
            <div class="zi-item row align-items-center mb-2" *ngFor="let zi of zile; let i = index">
                <div class="col-4">
                    <span class="zi-name">{{ getNumeZi(zi.day_of_week) }}</span>
                </div>
                <div class="col-5">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Ora</mat-label>
                        <input matInput
                            [(ngModel)]="zi.time_from"
                            [ngxMatTimepicker]="picker"
                            [format]="24"
                            placeholder="HH:MM" />
                        <ngx-mat-timepicker #picker color="primary"></ngx-mat-timepicker>
                    </mat-form-field>
                </div>
                <div class="col-3 text-end">
                    <button type="button" mat-icon-button color="warn" (click)="removeZi(i)"
                        title="Șterge ziua">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <div class="no-zile-message" *ngIf="zile.length === 0 && !showAddZi">
            <small class="text-muted">Nu există zile configurate. Adăugați cel puțin o zi.</small>
        </div>

        <!-- Adaugă zi nouă -->
        <div class="add-zi-section mt-3" *ngIf="!showAddZi && zileSaptamanaDisponibile.length > 0">
            <button type="button" mat-stroked-button color="primary" (click)="showAddZi = true">
                <mat-icon>add</mat-icon>
                Adaugă zi
            </button>
        </div>

        <div class="add-zi-form row align-items-center mt-3" *ngIf="showAddZi">
            <div class="col-4">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Zi</mat-label>
                    <mat-select [(ngModel)]="newZi.day_of_week">
                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let zi of zileSaptamanaDisponibile" [value]="zi.value">
                            {{ zi.key }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-4">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Ora</mat-label>
                    <input matInput
                        [(ngModel)]="newZi.time_from"
                        [ngxMatTimepicker]="newZiPicker"
                        [format]="24"
                        placeholder="HH:MM" />
                    <ngx-mat-timepicker #newZiPicker color="primary"></ngx-mat-timepicker>
                </mat-form-field>
            </div>
            <div class="col-4">
                <button type="button" mat-flat-button color="primary" (click)="addZi()" class="me-2">
                    Adaugă
                </button>
                <button type="button" mat-stroked-button (click)="cancelAddZi()">
                    Anulează
                </button>
            </div>
        </div>

        <div class="no-more-days mt-3" *ngIf="zileSaptamanaDisponibile.length === 0">
            <small class="text-muted">Toate zilele săptămânii sunt deja configurate.</small>
        </div>
    </div>

    <!-- Email comun -->
    <div class="email-section mb-4">
        <mat-form-field class="w-100" appearance="fill">
            <mat-label>Email-uri (pentru toate zilele)</mat-label>
            <input matInput [(ngModel)]="emails" placeholder="email1@ex.com;email2@ex.com">
            <mat-hint>Separate prin ; (punct și virgulă)</mat-hint>
        </mat-form-field>
    </div>

    <!-- Acțiuni -->
    <div class="row">
        <div class="col d-flex justify-content-between">
            <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" mat-flat-button color="primary" (click)="submitForm()" [disabled]="isLoading">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </div>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>
